import React from "react";
import { Button, Card, Skeleton } from "antd";
import { PlusOutlined, SendOutlined } from "@ant-design/icons";
import canadaFlag from "../../Image/ca-circle.png";
import barbadosFlag from "../../Image/flag/barbados.png";
import logoIcon from "../../Image/logo-icon.png";

const WalletCard = ({
  loading,
  wallet,
  onFundWallet,
  onSendFromWalletCard,
}) => {
  const walletCurrency = String(wallet?.currency || "CAD").toUpperCase();
  const walletFlag = walletCurrency === "BBD" ? barbadosFlag : canadaFlag;
  const formatNumber = (number, decimalPlaces = 2) =>
    Number(number || 0).toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });

  return (
    <div className="dashboardWalletColumn">
      <Card className="customCard dashboardWalletCard" bordered={false}>
        {loading ? (
          <Skeleton active paragraph={{ rows: 2 }} />
        ) : (
          <>
            <div className="dashboardWalletTopRow">
              <h3 className="dashboardWalletTitle">My Wallet</h3>
              <img
                src={walletFlag}
                alt={walletCurrency}
                className="dashboardWalletFlag"
              />
            </div>
            <p className="dashboardWalletMeta">
              {walletCurrency === "BBD"
                ? "Barbados Dollar (BBD)"
                : "Canadian Dollar (CAD)"}
            </p>
            <div className="dashboardWalletBalanceBlock">
              <h1 className="dashboardWalletAmount">
                ${formatNumber(wallet.availableBalance || 0, 2)}
                <span className="dashboardWalletAmountCode"> {walletCurrency}</span>
              </h1>
            </div>

            <div className="dashboardWalletActions">
              <Button
                className="dashboardWalletPillBtn"
                onClick={onFundWallet}
                disabled={!wallet.id}
                icon={<PlusOutlined style={{ fontSize: 13 }} />}
              >
                Add Funds
              </Button>
              <Button
                className="dashboardWalletPillBtn"
                onClick={onSendFromWalletCard}
                disabled={!wallet.id}
                icon={<SendOutlined style={{ fontSize: 13 }} />}
              >
                Send
              </Button>
            </div>
            <img
              src={logoIcon}
              alt="BajCan"
              className="dashboardWalletBrandMark"
            />
          </>
        )}
      </Card>
    </div>
  );
};

export default WalletCard;
